// ═══════════════════════════════════════════════════════════════════════════
// Punto de entrada de la consola de plataforma
//
// Gemelo de `main.jsx`, y deliberadamente más corto: aquí no se instalan los
// mapas de precio ni se monta `App`. Esta consola no vende nada.
// ═══════════════════════════════════════════════════════════════════════════

import React from "react";
import ReactDOM from "react-dom/client";
import { PlataformaApp } from "./PlataformaApp.jsx";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <PlataformaApp />
  </React.StrictMode>
);
